export default __webpack_public_path__ + "static/latitude-eco-mastercard-7207394e9ba83cb0c44adfe3777f225d.png";